import { Link } from "react-router-dom";
import React from "react";

const RawEditItemButton = ({ href = "edit", disabled = false, ...props }) => {
  if (disabled) {
    return (
      <span
        {...props}
        className="flex text-muted-foreground w-full cursor-not-allowed opacity-60"
      >
        Edit
      </span>
    );
  }
  return (
    <Link to={href} {...props} className="flex text-popover-foreground w-full">
      Edit
    </Link>
  );
};

export default RawEditItemButton;